import styled, { CSSObject } from 'styled-components';

interface BadgeStyledProps {
  selfContained: boolean;
  color?: 'success' | 'warning';
}

const NotificationBadgeStyled = styled.span({
  display: 'inline-flex',
  position: 'relative',
});

const BadgeValueStyled = styled.div<BadgeStyledProps>(
  ({ theme, color, selfContained }) => {
    let styleSheet: CSSObject = {
      // TODO create utility function theme.space(2)
      padding: `0 ${theme.space[1]}`,
      borderRadius: 100,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: theme.color.wfWhite,
      fontSize: theme.font.size.xxsmall,
      lineHeight: theme.font.size.xsmall,
      background: theme.color.wfOrange,
    };

    if (!selfContained) {
      styleSheet = {
        ...styleSheet,
        position: 'absolute',
        right: 0,
        top: 0,
        transform: 'scale(1) translate(50%, -50%)',
      };
    }

    if (color === 'success') {
      styleSheet.background = theme.color.wfGreen;
    }
    if (color === 'warning') {
      styleSheet.background = theme.color.wfRed;
    }

    return styleSheet;
  },
);

export { NotificationBadgeStyled, BadgeValueStyled };
